import { BrowserModule } from "@angular/platform-browser";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgOtpInputModule } from "ng-otp-input";
import { Ng5SliderModule } from "ng5-slider";
import { ChatSectionComponent } from "./chat-section/chat-section.component";
import { DeviceDetectorModule } from "ngx-device-detector";
import { MaterialModule } from "./material/material.module";
import { KycModalComponent } from "./modals/kyc-modal/kyc-modal.component";
import { DateFormat } from "./date-format";
import { DateAdapter } from "@angular/material/core";
import { inrFormat } from "./currencyFormat";
import { NgxAutoScrollModule } from "ngx-auto-scroll";
import { AutofocusModule } from "./directive/autofous/autofous.module";
import { DialogComponent } from "./modals/dialog/dialog.component";
import { NgxSpinnerModule } from "ngx-spinner";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SdDreamCamComponent } from "./0-shared-components/sd-dream-cam/sd-dream-cam.component";
import { LoaderComponent } from "./0-shared-components/loader/loader.component";
import { IDreamCamComponent } from "./0-shared-components/i-dream-cam/i-dream-cam.component";
import { NumberFormatDirectiveDirective } from "./directive/number-format-directive.directive";
import { CommonModule } from "@angular/common";

declare global {
  interface Window {
    webengage?: any;
  }
}

@NgModule({
  declarations: [
    AppComponent,
    ChatSectionComponent,
    KycModalComponent,
    inrFormat,
    DialogComponent,
    SdDreamCamComponent,
    LoaderComponent,
    IDreamCamComponent,
    NumberFormatDirectiveDirective,
  ],
  imports: [
    NgbModule,
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    MaterialModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    NgOtpInputModule,
    Ng5SliderModule,
    DeviceDetectorModule,
    NgxAutoScrollModule,
    AutofocusModule,
    NgxSpinnerModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [{ provide: DateAdapter, useClass: DateFormat }],
  bootstrap: [AppComponent],
})
export class AppModule {}
